import { render, staticRenderFns } from "./AddEmployeeDocumentModal.vue?vue&type=template&id=24617ef8&"
import script from "./AddEmployeeDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./AddEmployeeDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports